import type { AgentUiMessage, GeminiContent } from './types';

const STORAGE_KEY = 'agent.conversation.v1';
const MAX_UI_MESSAGES = 50;

export interface StoredConversation {
  uiMessages: AgentUiMessage[];
  contents: GeminiContent[];
}

export function loadConversation(): StoredConversation | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.uiMessages) || !Array.isArray(parsed.contents)) {
      return null;
    }
    return parsed as StoredConversation;
  } catch {
    return null;
  }
}

export function saveConversation(conversation: StoredConversation): void {
  try {
    const trimmed: StoredConversation = {
      uiMessages: conversation.uiMessages.slice(-MAX_UI_MESSAGES),
      contents: conversation.contents.slice(-MAX_UI_MESSAGES),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // ignore quota error
  }
}

export function clearConversation(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
